import { Injectable } from '@angular/core';
import { DATA_ABOUT } from '../data/about.data';
import { DATA_NEWS } from '../data/news.data';
import { DATA_PRODUCTS } from '../data/products.data';

@Injectable({
    providedIn: 'root'
})
export class CMSService {

    
    constructor() { }

    
    async getInfo() {
        return DATA_ABOUT;
    }

    async getProduct(code: number) {
        return DATA_PRODUCTS.find(item => {
            return item.Codigo == code
        });
    }


    async getProducts() {
        return DATA_PRODUCTS.map(item => {
            item.Capa = item.Imagens.find(i => i.Capa == true);
            return item;
        });
    }

    async getNews() {
        return DATA_NEWS;
    }


}
